import { render, staticRenderFns } from "./loyalty.vue?vue&type=template&id=77ba88dc&functional=true"
import script from "./loyalty.vue?vue&type=script&lang=js"
export * from "./loyalty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports